import { useForm, FormProvider } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import {
  NAME,
  KEY_TYPE,
  JWT_REQUIRED,
  CUSTOM_EVENT_MANAGE_ALLOW_CREATION,
  CUSTOM_EVENT_MANAGE_ALLOW_CREATION_UNTIL,
} from '../components/ApiKeyModal.constants';
import { API_KEY_TYPE_VALUES } from '../constants';

const schema = z.object({
  [NAME]: z.string().min(1, { message: 'Name is required' }),
  [KEY_TYPE]: z.string(),
  [JWT_REQUIRED]: z.boolean().optional(),
  [CUSTOM_EVENT_MANAGE_ALLOW_CREATION]: z.boolean(),
  /** Currently handled as a Moment object */
  [CUSTOM_EVENT_MANAGE_ALLOW_CREATION_UNTIL]: z.any(),
});

const emptyValues = {
  [NAME]: '',
  [KEY_TYPE]: API_KEY_TYPE_VALUES.READ_ONLY,
  [JWT_REQUIRED]: false,
  [CUSTOM_EVENT_MANAGE_ALLOW_CREATION]: false,
  [CUSTOM_EVENT_MANAGE_ALLOW_CREATION_UNTIL]: null,
};

type FormSchemaType = Required<z.infer<typeof schema>>;

export type ApiKeysFormContextType = FormSchemaType;

type ApiKeysFormProviderProps = {
  defaultValues?: ApiKeysFormContextType;
  children: React.ReactNode;
};

export const ApiKeysFormProvider = ({
  defaultValues = emptyValues,
  children,
}: ApiKeysFormProviderProps) => {
  const methods = useForm<FormSchemaType>({
    defaultValues,
    mode: 'onChange',
    resolver: zodResolver(schema),
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
